<template>
  <transition name="fade">
    <div class="mod-req-app">
      <div class="mod-req-app-container">
        <div class="btn-close" @click="closeModal()">
          X
        </div>
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            BLOCK VENDOR
          </div>
        </div>
        <div>Nama Vendor</div>
        <div>
          <div class="half-input-wrapper">
            <input
              type="text"
              :value="$get($store, 'state.myRequest.detail.nama_vendor')"
              class="hiw-text mr10"
              disabled
            />
          </div>
        </div>
        <div>
          <div>Bisnis Unit</div>
          <div class="flex-space-between">
            <div>
              <input
                type="radio"
                value="1"
                v-model="bisnisUnit"
                class="mr10"
                disabled
              />
              <label>GEMS</label>
            </div>
            <div>
              <input
                type="radio"
                value="2"
                v-model="bisnisUnit"
                class="mr10"
                disabled
              />
              <label>BCE</label>
            </div>
            <div>
              <input
                type="radio"
                value="3"
                v-model="bisnisUnit"
                class="mr10"
                disabled
              />
              <label>BKES</label>
            </div>
          </div>
        </div>
        <div>Company Code</div>
        <div>
          <div class="half-input-wrapper">
            <input
              type="text"
              :value="$get($store, 'state.myRequest.detail.company_code')"
              class="hiw-text mr10"
              disabled
            />
          </div>
        </div>
        <!-- <div>
          <div>Lampiran</div>
          <label class="btn btn-default btn-file">
            <i class="fas fa-upload"></i> {{ theFileName }}
            <input
              type="file"
              style="display: none;"
              @change="fileChangeHandler"
            />
          </label>
        </div> -->
        <div>
          <div>Catatan</div>
          <input
            type="text"
            class="input-100"
            :value="$get($store, 'state.myRequest.detail.note')"
            disabled
          />
        </div>
      </div>
      <div class="multy-btn-center" v-if="$route.path != '/myrequest'">
        <div class="flex-space-between">
          <div
            class="btn-small"
            v-if="
              $get($store, 'state.approvalSheet.status') != 9 &&
                $get($store, 'state.approvalSheet.status') != 5 &&
                $get($store, 'state.approvalSheet.status') != 4
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="approve()">
              Approve
            </div>
          </div>
          <div
            class="btn-small"
            v-if="
              $get($store, 'state.approvalSheet.status') == 9 &&
                $get($store, 'state.role_id') == 2
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="approveHead()">
              Approve Head
            </div>
          </div>
          <div
            class="btn-small"
            v-if="
              $get($store, 'state.approvalSheet.status') == 9 &&
                $get($store, 'state.role_id') == 2
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="reviewHead()">
              Review Head
            </div>
          </div>
          <div
            class="btn-small"
            v-if="
              $get($store, 'state.approvalSheet.status') != 9 &&
                $get($store, 'state.approvalSheet.status') != 5 &&
                $get($store, 'state.approvalSheet.status') != 4
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="reject()">
              Reject
            </div>
          </div>
          <div
            class="btn-small"
            v-if="
              $get($store, 'state.approvalSheet.status') != 9 &&
                $get($store, 'state.approvalSheet.status') != 5 &&
                $get($store, 'state.approvalSheet.status') != 4
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="postpone()">
              Postpone
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  data() {
    return {
      bisnis_unit: 0,
      vendors: [],
      gems: [],
      bc: [],
      bkes: [],
      files: [],
      choosedVendor: '',
      choosedGems: '',
      choosedBc: '',
      choosedBkes: '',
      notes: '',
    }
  },
  computed: {
    bisnisUnit() {
      return this.$get(this, '$store.state.myRequest.detail.bisnis_unit')
    },
    choosedBisnis: {
      get: function() {
        return this.bisnis_unit
      },
      set: function(newValue) {
        let company = ''

        if (newValue == 1) company = 'gems'
        if (newValue == 2) company = 'bc'
        if (newValue == 3) company = 'bkes'

        this.companyCode(company)
        this.bisnis_unit = newValue
      },
    },
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
  },
  methods: {
    async approve() {
      this.$store.dispatch('approvalSheet/approveVendor', {
        id: this.$get(this, '$store.state.myRequest.detail.request_id'),
      })
    },
    async approveHead() {
      this.$store.dispatch('approvalSheet/approveHead', {
        id: this.$get(this, '$store.state.myRequest.detail.request_id'),
      })
    },
    async reviewHead() {
      this.$store.dispatch('approvalSheet/reviewHead', {
        id: this.$get(this, '$store.state.myRequest.detail.request_id'),
      })
    },
    async reject() {
      this.$store.dispatch('approvalSheet/rejectVendor', {
        id: this.$get(this, '$store.state.myRequest.detail.request_id'),
      })
    },
    async postpone() {
      this.$store.dispatch('approvalSheet/postpone', {
        id: this.$get(this, '$store.state.myRequest.detail.request_id'),
      })
    },
    closeModal() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalViewBlock',
        value: false,
      })
    },
  },
}
</script>
